import PrioritizedArticleBlock from './PrioritizedArticleBlock';
export default PrioritizedArticleBlock;
